import Vue from 'vue'
const VueRouter = require('vue-router').default

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: () => import('../views/ProductDetail.vue'),
      props: true
    },
    {
      path: '/ai-finance',
      name: 'AiFinance',
      component: () => import('../views/AiFinance.vue')
    },
    {
      path: '/ai-law',
      name: 'AiLaw',
      component: () => import('../views/AiLaw.vue')
    },
    {
      path: '/case/:id',
      name: 'CaseDetail',
      component: () => import('../views/CaseDetail.vue'),
      props: true
    },
    {
      path: '/products',
      name: 'ProductsList',
      component: () => import('../views/ProductsList.vue')
    },
    {
      path: '/cases',
      name: 'CasesList',
      component: () => import('../views/CasesList.vue')
    },
    {
      path: '/expert/:id',
      name: 'ExpertDetail',
      component: () => import('../views/ExpertDetail.vue'),
      props: true
    },
    {
      path: '/experts',
      name: 'ExpertsList',
      component: () => import('../views/ExpertsList.vue')
    },
    {
      path: '/dynamics',
      name: 'DynamicList',
      component: () => import('../views/DynamicList.vue')
    },
    {
      path: '/investments',
      name: 'InvestmentList',
      component: () => import('../views/InvestmentList.vue')
    },
    {
      path: '/business',
      name: 'BusinessList',
      component: () => import('../views/BusinessList.vue')
    },
    {
      path: '/countries',
      name: 'CountryList',
      component: () => import('../views/CountryList.vue')
    },
    {
      path: '/country/:id',
      name: 'CountryDetail',
      component: () => import('../views/CountryDetail.vue'),
      props: true
    },
    {
      path: '/country-report/:id',
      name: 'CountryReport',
      component: () => import('../views/CountryReport.vue'),
      props: true
    },
    {
      path: '/oversea-service',
      name: 'OverseaService',
      component: () => import('../views/OverseaService.vue')
    },
    {
      path: '/oversea-service-list/:cat',
      name: 'OverseaServiceList',
      component: () => import('../views/OverseaServiceList.vue'),
      props: true
    },
    {
      path: '/oversea-service-info',
      name: 'OverseaServiceInfo',
      component: () => import('../views/OverseaServiceInfo.vue')
    },
    {
      path: '/oversea-report',
      name: 'OverseaReport',
      component: () => import('../views/OverseaReport.vue')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../views/About.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 百度统计：SPA（hash 路由）切换页面时手动上报 PV，否则只在首屏加载时统计一次
router.afterEach((to) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
